__turbopack_context__.v({
  "minimalistic": "XG7vMG_minimalistic",
  "navigationWrapper": "XG7vMG_navigationWrapper",
  "ribbonOpen": "XG7vMG_ribbonOpen",
  "tabletContent": "XG7vMG_tabletContent",
  "webContent": "XG7vMG_webContent",
});
